<template>
    <div id="wyfw">
        <headTop :id="id" @topback="topback"></headTop>
        <detailTop :name="name" :text="text" :detailid="detailid"></detailTop>
        <detailBread :breadName="breadName"></detailBread>
        <div class="wsbxContent">
            <div class="wsbxContent_">
                <div class="wsbxContent_1 clearfix">
                    <div class="left">
                        <h3><span>功能全面完善</span> <i class="wyfwh1"></i></h3>
                        <div class="left_text">
                            <h3>业务闭环：</h3>
                            <p>检查任务下发、执行检查、问题整改 <br> 反馈、整改确认</p>
                            <h3>多方位监管：</h3>
                            <p>检查任务监督、企业服务质量考核、<br>问题整改监管</p>
                        </div>
                    </div>
                    <div class="right"></div>
                </div>
                <div class="wsbxContent_2 wyfwContent_2">
                    <div class="left"></div>
                    <div class="right">
                        <h3><span>支持多种检查类型</span> <i class="xsdch2"></i></h3>
                        <div class="left_text">
                            <p>检查监督，支持多种类型的检查任务下发以及执行情况的监管，覆盖全校物业检查点：</p>
                            <h3>常规检查：<span>定期定频的常规检查任务配置及执行</span></h3>
                            <h3>专项检查：<span>特定专题的专项检查任务下发</span></h3>
                            <h3>随机检查：<span>随时发现问题随手拍</span></h3>
                        </div>
                    </div>
                </div>
                <div class="wsbxContent_3">
                    <div class="left">
                        <h3><span>检查标准自定义</span> <i class="wsbxh3"></i></h3>
                        <div class="left_text">
                            <h3>服务质量考核：</h3>
                            <p>自定义检查标准，根据检查情况对各个检 <br> 查点的服务企业进行绩效考核及汇总</p>
                        </div>
                    </div>
                    <div class="right"></div>
                </div>
                <div class="wsbxContent_2 wsbxContent_4">
                    <div class="left"></div>
                    <div class="right">
                        <h3><span>反馈与确认</span> <i class="wyfwh4"></i></h3>
                        <div class="left_text">
                            <h3>问题整改反馈及整改确认：</h3>
                            <p>问题一经检查发现，立即待办任务及消息通知，<br>责任到人，提高问题整改速度，整改后需检查人<br>员确认通过，否则继续整改</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import headTop from '@/components/headTop'
import detailTop from '@/components/detailTop'
import detailBread from '@/components/detailBread'
export default {
    metaInfo: {
        title: '物业服务监管平台', // set a title
        meta: [{             // set meta
            name: 'keyWords',
            content: '物业服务监管平台'
        },
        {
            name: 'description',
            content: '物业服务监管平台'
        }],
    },
    components:{
        detailTop,
        detailBread,
        headTop
    },
    data() {
        return {
            id:'1',
            detailid:2,
            name:'物业服务监管平台',
            text:'物业服务监管平台以检查任务为核心，实现物业服务的检查任务下发、执行检查、问题整改反馈及确认的业务流程闭环，为物业服务质量的监管提供依据。',
            breadName:'物业服务监管平台'
        }
    },
    methods: {
        topback(){
            this.$router.push({
                path:'/',
            })
        }
    },
    mounted() {
        $('html,body').animate({
            scrollTop: 0 + "px"
        }, {
            duration: 0,
            easing: "swing"
        });
        return false;
    },
    
}
</script>


// WEBPACK FOOTER //
// src/pages/wyfw.vue